import type { JiraServiceManagementComment } from '../../types';

export const isJiraServiceManagementComment = (
	entity: any,
): entity is JiraServiceManagementComment => entity.__typename === 'JiraServiceManagementComment';

export const getJiraServiceManagementCommentLink = (
	comment: JiraServiceManagementComment,
): string | null => comment?.webUrl ?? null;
